module.exports = __webpack_public_path__ + "static/media/2DGACM9.444d7adb.jpg";